export function validateOrgName(value) {
    const length = value.length;

    if( length < 1 ) {
        return {
            value: value,
            isValid : false,
            message : "Error: Please enter a Name."
        }
    }
    else if (length > 50) {
        return {
            value: value,
            isValid : false,
            message : "Error: Name cannot exceed 50 characters in length."
        }
    }
    else if (length >= 1 && length <= 50) {
        const orgRegex = /^(?=.*?[a-zA-Z0-9])[a-zA-Z0-9-.][A-Za-z0-9- .&*$@#!:;=_?%]*[A-Za-z0-9-.&*$@#!:;=_?%]$/;
        let emailMatches = orgRegex.test(value);
        if(!emailMatches) {
            return {
                value: value,
                isValid : false,
                message : "Error: Please use only English, alphanumeric characters. Spaces, periods, and these special characters are allowed - & * $ @ # ! : ; = ? _ % (no commas). Other than alphanumeric characters, only . and - are allowed at the beginning. No leading or trailing spaces."
            }
        } else {
            return {
                value: value,
                isValid : true,
                message : ""
            }
        }
    }
}
export default validateOrgName;


// WEBPACK FOOTER //
// ./src/helper/validateOrgName.js